export default class GameModel {
    /**
     * @abstract
     */
    constructor() {
    }

    /**
     * Perform full reset for:
     * 1. Delete all progress and start over.
     * 2. Prepare for save load.
     * @abstract
     */
    resetFull() {
    }

    /**
     * Just reset run-scoped data. 
     * Don't wipe out the skill tree or the prestige currency.
     * @abstract
     */
    resetForPrestige() {
    }

    
}